export default __webpack_public_path__ + "static/media/background.0c8a4828.png";